import { Component, HostListener, inject, OnInit, input, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { MatIcon } from '@angular/material/icon';
import { JkeditComponent } from '../jkedit/jkedit.component';
import { JkBaseComponent } from '../jkbase/jkbase.component';
import { AppPage } from '../../services/jkClass';
import { JkMenuService } from '../../services/jkmenu.service';


@Component({
  selector: 'app-jkmenu',
  templateUrl: './jkmenu.component.html',
  styleUrls: ['./jkmenu.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    JkeditComponent,
    MatIcon,
  ],
})
export class JkmenuComponent extends JkBaseComponent implements OnInit {
  myMenu = inject(JkMenuService);

  override comType: string = 'jkmenu';
  noPage: AppPage = {
    id: 'error404',
    title: '未設定menu',
    url: '',
    isCheckPower: false,
  }
  readonly pages = input<AppPage[]>([]);
  /*get tree(): AppPage[] {
    return menuTree;
  }*/
  /*@Input()
  set tree(tree: AppPage[]) {
    if (this.myMenu) {
      this.myMenu.menuTree = tree;
        //this.myMenu.init(this._router, this._pages, this._tree);
    }
  }
  get tree(): AppPage[] {
    if (this.myMenu) {
      return this.myMenu.menuTree;
    }else
    return [this.noPage];
  }*/
  /*get router(): Router {
    return this.myMenu.router;
  }
  set router(router: Router) {
    if (this.myMenu) {
      this.myMenu.router = router;
    }
  }*/
  /*@Input()
  get pages(): AppPage[] {
    return jkGlb.pages;
  }*/
  router: Router = inject(Router);
  override ngAfterViewInit(): void {
    super.ngAfterViewInit();
    //this.myMenu.init();
  }

  // ### [以上是必要的]================================

  mergePageAndTree(pages: AppPage[], tree: AppPage[]) {
    if (this.myMenu)
      this.myMenu.mergePageAndTree(pages, tree)
    else
      console.log('mergePageAndTree:myMenu is undefined');
  }
  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      if (this.myMenu.callProgramId !== '')
        this.myMenu.doProgramId(this.pages());
    }
  }
  doProgramId() {
    this.myMenu.doProgramId(this.pages());
  }

}
